import clsx from 'clsx';
import type * as React from 'react';

import { MARK_DIFF_ADDED, MARK_DIFF_DELETED, MARK_DIFF_MODIFIED } from '@gitbook/doc-core';
import type { MarkProps } from '@gitbook/slate-react';

import { DIFF_BACKGROUND_COLORS } from '../../Diff';

/*
 * Renderer for a diff mark.
 */
export function MarkDiff(props: MarkProps): React.ReactElement {
    const { mark, attributes, children } = props;

    return (
        <span
            className={clsx(
                getMarkDiffColor(mark.type),
                mark.type === MARK_DIFF_DELETED ? 'line-through' : null
            )}
            {...attributes}
        >
            {children}
        </span>
    );
}

function getMarkDiffColor(type: string) {
    switch (type) {
        case MARK_DIFF_ADDED:
            return DIFF_BACKGROUND_COLORS.added;
        case MARK_DIFF_DELETED:
            return DIFF_BACKGROUND_COLORS.deleted;
        case MARK_DIFF_MODIFIED:
            return DIFF_BACKGROUND_COLORS.modified;
        default:
            return undefined;
    }
}
